var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#app' }),expression:"{ el: '#app' }"}],staticClass:"go-top-btn"})}
var staticRenderFns = []

export { render, staticRenderFns }